const RevenueSpendCrudModalLangKey = [
	'title_create',
	'title_edit',
	'title_remove_single',
	'title_notes_view',
	'title_notes_edit',
	'title_history_view',
	'title_select_users',
	'label_mode_revenue_cpa',
	'label_mode_revenue_spend',
	'label_mode_revenue',
	'title_by_account_revenue',
	'title_by_account_revenue_total',
	'title_by_account_offer_spend',
	'title_by_account_offer_spend_total',
	'title_by_account_spend',
	'title_by_account_spend_total',
	'title_by_team_revenue',
	'title_by_team_revenue_total',
	'title_by_team_offer_spend',
	'title_by_team_offer_spend_total',
	'title_by_team_spend',
	'title_by_team_spend_total',
	'field_agency_label',
	'field_agency_placeholder',
	'field_account_label',
	'field_account_placeholder',
	'field_kt_group_label',
	'field_kt_group_placeholder',
	'field_date_label',
	'field_date_placeholder',
	'field_amount_label',
	'field_amount_placeholder',
	'field_notes_label',
	'field_notes_placeholder',
	'msg_remove_confirm',
	'btn_select_users',
	'btn_create',
	'btn_update',
	'btn_remove',
	'btn_close'
] as const

type IRevenueSpendCrudModalLangKey = typeof RevenueSpendCrudModalLangKey[number]

export type IRevenueSpendCrudModalLang = {
	revenue_spend_crud_modal: Record<IRevenueSpendCrudModalLangKey, string>
}

const langEntries = RevenueSpendCrudModalLangKey.map(
	(key: IRevenueSpendCrudModalLangKey) => [key, `revenue_spend_crud_modal.${key}`]
)

const langObj: Record<IRevenueSpendCrudModalLangKey, string> = Object.fromEntries(langEntries)

export const REVENUE_SPEND_CRUD_MODAL_LANG_KEY: IRevenueSpendCrudModalLang = {
	revenue_spend_crud_modal: langObj
}